import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { useLocation, useHistory } from "react-router-dom";

import { ButtonGroup } from "core/ButtonGroup";

import { GET_TOTAL_COUNTS_FOR_SEARCH_TYPES } from "./queries";

import { SEARCH_TYPES } from "./helpers";
import { SEARCH_ICONS, SEARCH_ICON_COLLECTIONS } from "data/links";

const SearchSegmentedControlButtons = ({ query, activeSearchType }) => {
    const history = useHistory();
    const location = useLocation();

    const { data, loading } = useQuery(GET_TOTAL_COUNTS_FOR_SEARCH_TYPES, {
        variables: { query }
    });

    if (loading) return null;

    const iconsTotal = data.icons.totalCount;
    const iconCollectionsTotal = data.collections.totalCount;

    const redirectTo = ({ pathname }) => () => {
        const newLocation = {
            ...location,
            pathname
        };

        history.push(newLocation);
    };

    return (
        <ButtonGroup
            buttons={[
                {
                    label: `${iconsTotal} Icons`,
                    isActive: SEARCH_TYPES.ICONS === activeSearchType,
                    onClick: redirectTo({ pathname: SEARCH_ICONS })
                },
                {
                    label: `${iconCollectionsTotal} Icon Collections`,
                    isActive:
                        SEARCH_TYPES.ICON_COLLECTIONS === activeSearchType,
                    onClick: redirectTo({
                        pathname: SEARCH_ICON_COLLECTIONS
                    })
                }
            ]}
        />
    );
};

export default SearchSegmentedControlButtons;
